(function(){
    'use strict'

    angular
    .module('app.ordenes')
    .controller('ordenes.Anular', Anular);

    Anular.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams','ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment'];

    function Anular($q, $scope, $animationsSrv, $routeParams, ApiBaseService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();
        const apiOrdenes = 'api/Ordenes'
        const companiaId = UserInfoService.getCompaniaId();

        let vm = this;

        vm.data = {
        };

        vm.title = 'Anular Orden';
        vm.id = $routeParams.id ? $routeParams.id : 0;

        get();

        function get(){

                if(vm.id != 0){
                    ApiBaseService.remoteController = apiOrdenes;
                    var promise = ApiBaseService.getAll([companiaId, vm.id]);

                    promise
                    .then(function(data){
                        data.fecha = moment(data.fecha).toDate();
                        data.contratoId = data.contrato.id;
                        data.contratoCodigo = data.contrato.codigo;
                        data.clienteId = data.contrato.clienteId;
                        data.proyectoId = data.contrato.proyectoId;
                        data.todosLosProyectos = data.contrato.todosLosProyectos;
                        vm.data = data;
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 401:
                                logger.error('La sesión ha expirado');
                                break;
                        
                            default:
                                logger.error('Hubo un error al obtener el registro: ' + error.data.Message);
                                break;
                        }
                    });               
                }
                else
                {
                    logger.error('No se ha especificado el numero de orden');
                }

        };

        vm.save = function(){

            $scope.submitted = true;

            if($scope.dataForm.$valid){
                if(!vm.data.id){
                    logger.error('No se ha definido una orden!');
                }
                else
                {
                    update();
                }
            }     
        
        };

        function update(){
            vm.data.cia_codigo = companiaId;
            ApiBaseService.remoteController = `${apiOrdenes}/Anular`;

            var transform  = {
                ordenId: vm.data.id,
                detalleAnulacion: vm.data.detalleAnulacion
            };

            var promise = ApiBaseService.update(transform);
            
            promise
            .then(function(response){
                logger.success('Orden Anulada con éxito.');
                $location.path('/ordenes');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al firmar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        function clearData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.data = {};
            // Set back to pristine.
            $scope.dataForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.dataForm.$setUntouched();
        };

    }
})();